<div class="modal-header" appCustomAutofocus>
    <h3 *ngIf="mode == 'reset'">Reset Task</h3>
    <h3 *ngIf="mode == 'delete'">Delete Task</h3>
</div>
<div class="modal-body">
    <div role="alert" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-default' : alert.type == 'default', 'alert-danger': alert.type == 'danger' }" *ngIf="alert != null">{{alert.msg}}</div>
    <p>Are you sure you want to <span *ngIf="mode == 'reset'">reset</span> <span *ngIf="mode == 'delete'">remove</span> the following task from {{pageData.FirstName}} {{pageData.LastName}}'s onboarding process?</p>

    <p><b>{{task.OnboardTaskName}}</b></p>
</div>
<div class="modal-footer">
    <button *ngIf="mode == 'reset'" class="btn btn-primary" type="button" (click)="resetClicked()">Reset</button>
    <button *ngIf="mode == 'delete'" class="btn btn-danger" type="button" (click)="deleteClicked()">Remove</button>
    <button class="btn btn-outline-dark" type="button" (click)="closeClicked()">Close</button>
</div>